let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("enZMg")).then(() => parcelRequire('l6D6l'));